/**
 * SpecializedDrilldownModals - CR-6310
 *
 * Bridges the DrilldownContext with specialized modal components (OTIF, OTD).
 * When DrilldownTrigger opens a metric that has a specialized modal,
 * this component renders the appropriate modal connected to the context state.
 */
import { useDrilldown } from '../../contexts/DrilldownContext';
import OTIFDrilldownModal from './OTIFDrilldownModal';
import OTDDrilldownModal from './OTDDrilldownModal';

const OTIF_METRICS = ['otif', 'otif_lines'];
const OTD_METRICS = ['otd', 'otd_lines'];

export default function SpecializedDrilldownModals() {
  const { state, closeDrilldown } = useDrilldown();

  // OTIF specialized modal
  if (state.isOpen && state.metric && OTIF_METRICS.includes(state.metric)) {
    return (
      <OTIFDrilldownModal
        isOpen={true}
        onClose={closeDrilldown}
        filters={state.filters as Record<string, unknown>}
        contextLabel={state.contextLabel || undefined}
        headline={state.headline || undefined}
        initialTab={state.pendingInitialTab as 'failed' | 'arrears' | 'positive' | 'total' | undefined}
      />
    );
  }

  // OTD specialized modal
  if (state.isOpen && state.metric && OTD_METRICS.includes(state.metric)) {
    return (
      <OTDDrilldownModal
        isOpen={true}
        onClose={closeDrilldown}
        filters={state.filters as Record<string, unknown>}
        contextLabel={state.contextLabel || undefined}
        headline={state.headline || undefined}
        initialTab={state.pendingInitialTab as 'on_time' | 'late' | 'total' | undefined}
      />
    );
  }

  return null;
}
